// /billings/profiles responde un envelope paginado { pagination, results }
// (con tolerancia a un array plano). Normalizador único del "perfil de
// facturación vigente" (el primero) para todos los consumidores del checkout —
// leer `data[0]` a secas es un bug (siempre undefined sobre el envelope).
export function firstBillingProfile(data) {
  const results = Array.isArray(data) ? data : (data?.results ?? []);
  return results[0] ?? null;
}
